import { render, staticRenderFns } from "./CarDetail.vue?vue&type=template&id=95d4c7ae&scoped=true&"
import script from "./CarDetail.vue?vue&type=script&lang=js&"
export * from "./CarDetail.vue?vue&type=script&lang=js&"
import style0 from "./CarDetail.vue?vue&type=style&index=0&id=95d4c7ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d4c7ae",
  null
  
)

export default component.exports